const styles: { container: string; title: string; description: string; actionTitle: string } = {
  container: 'flex items-center gap-4 text-xs select-none',
  title: 'font-medium mb-2 text-danger text-base',
  description: 'mb-4 text-sm font-normal',
  actionTitle: 'text-sm font-medium text-primary',
};

export default styles;
